(function($) {

	// Accordion
	//===========================================
	var accordionToggle = function() {

		var toggle = function( $panel ) {
			if ( $panel.hasClass('panel-opening') || $panel.hasClass('panel-closing') ) return;

			if ( $panel.hasClass('panel-open') ) {
				close( $panel );
			}

			if ( $panel.hasClass('panel-closed') ) {
				closeAll( $panel.parents('[data-accordion="group"]') );
				open( $panel );
			}
		}

		var open = function( $panel ) {
			var $wrapper = $panel.find('[data-accordion="wrapper"]');
			var $toggle = $panel.find('[data-accordion="toggle"]');
			var toHeight = $wrapper.get(0).scrollHeight;

			$panel.addClass('panel-opening');

			$wrapper.animate({
				height: toHeight
			}, 400, function() {
				$panel.removeClass('panel-opening')
					  .removeClass('panel-closed')
					  .addClass('panel-open');

				$toggle.attr('aria-expanded', 'true');

				$wrapper.attr('style', '');
			});
		}

		var close = function( $panel ) {
			var $wrapper = $panel.find('[data-accordion="wrapper"]');
			var $toggle = $panel.find('[data-accordion="toggle"]');
			var startHeight = $wrapper.get(0).scrollHeight;

			$panel.addClass('panel-closing');

			$wrapper.height(startHeight).animate({
				height: 0
			}, 400, function() {
				$panel.removeClass('panel-closing')
					  .removeClass('panel-open')
					  .addClass('panel-closed');

				$toggle.attr('aria-expanded', 'false');

				$wrapper.attr('style', '');
			});
		}

		var closeAll = function( $group ) {
			var $panels = $group.find('[data-accordion="panel"]');

			$panels.each(function() {
				if ( $(this).hasClass('panel-open') ) {
					close( $(this) );
				}
			});
		}

		return {

			bind: function() {
				$('a[data-accordion="toggle"], button[data-accordion="toggle"]').on('click', function(e) {
					e.preventDefault();
					toggle( $(this).parents('[data-accordion="panel"]') );

				});
			}
		}
	}

	accordionToggle().bind();

})(jQuery);